import { useQuery } from "@tanstack/react-query";
import { retrieveFileOptions } from "@/lib/data/react-query/files/canonical-files";
import type { CanonicalFile } from "@/lib/data/schemas/files";

function FolderPath({ id, visited = [] }: { id: string; visited?: string[] }) {
  const folder = useQuery({
    ...retrieveFileOptions(id, !visited.includes(id)),
    staleTime: 60_000,
    retry: false,
  });
  if (visited.includes(id)) return <>Nested folder</>;
  if (!folder.data)
    return <>{folder.isError ? "Nested folder" : "Loading folder…"}</>;
  return (
    <>
      {folder.data.parentId && (
        <>
          <FolderPath id={folder.data.parentId} visited={[...visited, id]} /> /{" "}
        </>
      )}
      {folder.data.name}
    </>
  );
}

export function GlobalFileSearchLocation({
  file,
  matterTitles,
  massTortTitles,
}: {
  file: CanonicalFile;
  matterTitles: Record<string, string>;
  massTortTitles: Record<string, string>;
}) {
  const repository =
    file.scope === "template"
      ? "Templates"
      : file.scope === "firm"
        ? "Firm files"
        : file.scope === "personal"
          ? "Personal files"
          : file.scope === "matter"
            ? matterTitles[file.matterId ?? ""] || "Matter files"
            : massTortTitles[file.massTortId ?? ""] || "Mass-tort files";
  return (
    <>
      {repository} /{" "}
      {file.parentId ? <FolderPath id={file.parentId} /> : "Root folder"}
    </>
  );
}
